import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import {
  Input,
  Button,
  Select,
  Alert,
  message,
  Checkbox,
  Typography,
} from 'antd';
import { getChannelList } from '../../../skills_action';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import {
  handleSendNotifications,
  slackInfo,
} from 'components/skills/cardSkill/report_actions';
import slackChannel from './slackChannel';
import MemberSelect from 'components/common/memberSelect';

const { Text, Title } = Typography;
//import {updateCard} from ".././CardActions";

const { Option } = Select;
const { TextArea } = Input;

const Recipient = (props) => {
  const dispatch = useDispatch();

  let slackData = useSelector((state) => state.report.slackData);
  const reportData = useSelector((state) => state.report);
  const [selectedChannel, setSelectedChannel] = useState(
    slackData && slackData.slackChannel ? slackData.slackChannel : []
  );
  const [reportMembers, setReportMembers] = useState(
    slackData && slackData.reportMembers ? slackData.reportMembers : []
  );
  const [sendNotificationMessage, setSendNotificationMessage] = useState(
    reportData && reportData.sendNotificationMessage
  );

  useEffect(() => {
    if (props.channels && props.channels.length === 0) {
      props.getChannelList(props.match.params.wId);
    }
  }, []);

  const getOptions = () => {
    return props.channels.map((channel) => {
      return (
        <Option key={channel.id} value={channel.id}>
          {channel.name}
        </Option>
      );
    });
  };

  const getUserIdFromArrays = (selectedMembers, membersList) => {
    return selectedMembers.map((element) => {
      const mongoIdRegex = /^[0-9a-fA-F]{24}$/; // Regex to match a MongoDB ObjectID
      if (mongoIdRegex.test(element)) {
        return element;
      }

      const matchedItem = membersList.find((item) => {
        return (
          element === item.slackInfo.displayName ||
          element === item.slackInfo.name ||
          element === item.slackInfo.user_name
        );
      });

      return matchedItem ? matchedItem.user_id : null;
    });
  };

  const onChange = (type, val) => {
    if (type == 'members') {
      const memberIds = getUserIdFromArrays(val, props.membersList);
      dispatch(
        slackInfo({
          ...slackData,
          reportMembers: memberIds,
        })
      );
      setReportMembers(val);
    } else if (type == 'channel') {
      dispatch(
        slackInfo({
          ...slackData,
          slackChannel: val,
        })
      );
      setSelectedChannel(val);
    } else if (type == 'notification') {
      dispatch(handleSendNotifications(val));
      setSendNotificationMessage(val);
    }
  };

  const checkIfReportContainsUserIdOrUserObj = (members) => {
    let memberArrWithIds =
      members &&
      members.map((member) => {
        const selectedMember =
          props.membersList &&
          props.membersList.find((memberItem) => memberItem.user_id === member);
        if (selectedMember && selectedMember.slackInfo) {
          return (
            selectedMember.slackInfo.displayName ||
            selectedMember.slackInfo.name ||
            selectedMember.slackInfo.user_name
          );
        } else {
          return (
            member.displayName ||
            member.name ||
            member.user_name ||
            member.email ||
            member
          );
        }
      });
    return memberArrWithIds;
  };
  const validateChannels = (channels, selectedChannels) => {
    let notExistChannels = [];
    if (selectedChannels) {
      if (Array.isArray(selectedChannels)) {
        selectedChannels.map((schannel) => {
          if (channels.some((channel) => channel.id === schannel)) {
          } else {
            notExistChannels.push(schannel);
          }
        });
      } else {
        if (channels.find((c) => c.id === selectedChannels)) {
        } else {
          notExistChannels = selectedChannels;
        }
      }
    }
    return notExistChannels;
  };
  let channel = selectedChannel
    ? selectedChannel
    : props.data && props.data.slackData && props.data.slackData.slackChannel;
  const notExistChannels = validateChannels(props.channels, channel);
  return (
    <div>
      {/* <TextArea name='slack_message' placeholder='Slack Message' /> */}

      <div style={{ display: 'flex', flexDirection: 'column' }}>
        <div
          style={{ display: 'flex', marginBottom: 24, alignItems: 'center' }}
        >
          <Text strong style={{ minWidth: '100px' }}>
            Share with
          </Text>
          <MemberSelect
            placeholder='Select Members'
            optionFilterProp='children'
            mode='multiple'
            onChange={(val) => onChange('members', val)}
            showSearch
            value={checkIfReportContainsUserIdOrUserObj(reportMembers)}
            // value={reportMembers}
            // defaultUsers={checkIfReportContainsUserIdOrUserObj(reportMembers)}
            defaultUsers={reportMembers || slackData.reportMembers}
            style={{ width: '100%' }}
          />
        </div>
      </div>
      {channel && notExistChannels.length > 0 ? (
        <Alert
          message={`Troopr was removed from channel ${notExistChannels}`}
          type='warning'
          showIcon
          style={{
            width: 'calc(100% - 16px)',
            maxWidth: 984,
            marginBottom: 24,
          }}
        />
      ) : null}

      <div style={{ display: 'flex', flexDirection: 'column' }}>
        <div
          style={{ display: 'flex', marginBottom: 10, alignItems: 'center' }}
        >
          <Text strong style={{ minWidth: '100px' }}>
            Send to{' '}
          </Text>
          <Select
            onChange={(val) => onChange('channel', val)}
            showSearch
            value={selectedChannel}
            style={{ width: '100%' }}
            placeholder='Select a Channel'
            filterOption={(input, option) =>
              option.props.children
                .toLowerCase()
                .indexOf(input.toLowerCase()) >= 0
            }
            mode={props.selectMode}
          >
            {getOptions()}
          </Select>
        </div>
        <div
          style={{
            marginTop: 8,
          }}
        >
          <Checkbox
            checked={sendNotificationMessage}
            onChange={(e) => onChange('notification', e.target.checked)}
            style={{ margin: '0px 16px 0px 100px' }}
          ></Checkbox>
          <span>Enabled to send notification by default</span>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    channels: state.skills.channels,
    allUsers: state.skills.members,
    slackInfo: state.report.slackData,
  };
};

export default withRouter(
  connect(mapStateToProps, { getChannelList })(Recipient)
);
